const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const BoatService = {
  async fetchBoats(page = 1, filterType = 'price', filterValue = 'featured') {
    try {
      let url = `${API_BASE_URL}/boats/?page=${page}`;
      
      // Aplicar filtro según el tipo activo
      if (filterType === 'category') {
        // Filtro por categoría - usar filterValue.id en lugar de filterValue.category_id
        url += `&category_id=${filterValue.id}`;
        // No aplicar otros filtros
      } else if (filterType === 'size') {
        // Filtro por tamaño
        url += `&size_range=${filterValue.range}`;
        // No aplicar otros filtros
      } else {
        // Filtro por precio/featured (default)
        url += `&filter=${filterValue}`;
        // No aplicar otros filtros
      }
      
      const response = await fetch(url);
      
      if (!response.ok) {
        const error = new Error(`HTTP ${response.status}: ${response.statusText}`);
        error.status = response.status;
        throw error;
      }
      
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async fetchBoatById(boatId) {
    try {
      const response = await fetch(`${API_BASE_URL}/boat/${boatId}/`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async fetchRelatedBoats(boatId) {
    try {
      const response = await fetch(`${API_BASE_URL}/boats/${boatId}/related/`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async fetchCategories() {
    try {
      const response = await fetch(`${API_BASE_URL}/categories/`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async fetchBoatNamesForFomo() {
    try {
      const response = await fetch(`${API_BASE_URL}/boats-fomo-names/`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      return data.boats || [];
    } catch (error) {
      console.error('Error fetching boat names for FOMO:', error);
      // Fallback a nombres hardcodeados en caso de error
      return [
        { id: 1, name: "Azimut 66ft" },
        { id: 2, name: "Azimut 94ft" },
        { id: 3, name: "Azimut Flybridge 75ft" },
        { id: 4, name: "Azimut Flybridge 53ft" },
        { id: 5, name: "Explorer 65ft" },
        { id: 6, name: "Pershing 94ft" },
        { id: 7, name: "Hurricane 25ft" },
        { id: 8, name: "Yamaha 25ft" }
      ];
    }
  },
};

export default BoatService;
